<template>
    <ClientSummary
        v-if="!isError.hasError && !isLoading"
        :client="infoClient"
        :ui="ui"
        :balance="infoClient.total"
        :status-class="typeClassConvenio"
        @back="$emit('back')"
    />
    <div class="container_submenu" v-if="!isError.hasError && !isLoading">
        <header>
            <v-card-title>Domicilios</v-card-title>
            <v-divider class="mx-3"></v-divider>
        </header>

        <div class="content_accion">
            <div>
                <v-text-field
                    v-model="searchDirecciones"
                    label="Búsqueda"
                    prepend-inner-icon="mdi-magnify"
                    single-line
                    variant="outlined"
                    hide-details
                    class="filter"
                    :disabled="isLoading"
                ></v-text-field>
            </div>
            <div>
                <v-btn
                    icon="mdi-reload"
                    size="small"
                    variant="outlined"
                    color="indigo-darken-3"
                    class="mr-2"
                    :disabled="isLoading"
                    @click="getDirectionsHomeAndWorkByClient()"
                ></v-btn>
                <v-btn
                    prepend-icon="mdi-plus"
                    color="indigo-darken-3"
                    class="elevation-0 text-none"
                    @click="dialogDirection = true; typeFormDirection.type = 'R';"
                    :disabled="isLoading"
                    text="Registrar"
                ></v-btn>
            </div>
        </div>
        <v-data-table
            :headers="headersAdress"
            :items="dataSourceDirecciones.data"
            :search="searchDirecciones"
            :loading="isLoading"
            no-data-text="Sin datos para mostrar"
            loading-text="Cargando información... Espere un momento"
        >
            <template v-slot:[`item.actions`]="{ item }">
                <td>
                    <v-tooltip text="Editar" location="bottom" v-if="tipoUsuario === 'Administrador'">
                        <template v-slot:activator="{ props }">
                            <v-btn
                                v-bind="props"
                                class="elevation-0 mr-1"
                                density="comfortable"
                                icon="mdi-pencil"
                                color="indigo-darken-3"
                                :disabled="isLoading"
                                @click="editDirection(item)"
                            ></v-btn>
                        </template>
                    </v-tooltip>

                    <v-tooltip text="Eliminar" location="bottom" v-if="permissions">
                        <template v-slot:activator="{ props }">
                            <v-btn
                                v-bind="props"
                                class="elevation-0"
                                density="comfortable"
                                icon="mdi-delete"
                                color="error"
                                :disabled="isLoading"
                                @click="deleteDirection(item)"
                            ></v-btn>
                        </template>
                    </v-tooltip>
                </td>
            </template>
        </v-data-table>
    </div>
    <div v-if="isError.hasError && !isLoading" class="has_error">
        <div>
            <img src="@/assets/images/hasError.svg">
        </div>
        <div>{{ isError.msg }}</div>
    </div>
    <div v-if="isLoading" class="content_load h-100" >
        <v-progress-circular
            :size="100"
            :width="7"
            color="indigo-darken-3"
            indeterminate
        ></v-progress-circular>
        <i>Espere un Momento</i>
        <div>Cargando la Información de los Domicilios</div>
    </div>

    <template>
        <v-dialog v-model="dialogDirection" width="600px" persistent>
            <v-card>
                <v-card-title class="text-h5">
                        {{ typeFormDirection.type === 'R' ? 'Registro de Domicilio' : 'Modificación de Domicilio' }}
                </v-card-title>
                <v-card-text>
                    <form class="override_content_flex">
                        <div class="col-flex-6">
                            <v-text-field 
                            label="Domicilio" 
                            variant="outlined" 
                            class="w-100"
                            v-model="formGroupDirection.data.direccion"
                            :rules="formGroupDirection.rules.direccion">
                            </v-text-field>
                        </div>
                        <div class="col-flex-6">
                            <v-text-field 
                            label="Número Exterior" 
                            variant="outlined" 
                            class="w-100"
                            v-model="formGroupDirection.data.num_ext"
                            :rules="formGroupDirection.rules.num_ext">
                            </v-text-field>
                        </div>
                        <div class="col-flex-6">
                            <v-text-field 
                            label="Número Interior" 
                            variant="outlined" 
                            class="w-100"
                            v-model="formGroupDirection.data.num_int"
                            :rules="formGroupDirection.rules.num_int">
                            </v-text-field>
                        </div>
                        <div class="col-flex-6">
                            <v-select
                            label="Tipo Domicilio" 
                            variant="outlined"
                            class="w-100"
                            v-model="formGroupDirection.data.tipo_direccion"
                            :rules="formGroupDirection.rules.tipo_direccion"
                            :items="[{key: 'casa', value: 'Casa'},{key: 'trabajo', value: 'Trabajo'}]"
                            item-title="value"
                            item-value="key"
                            >
                            </v-select>
                        </div>
                        <div class="col-flex-6" v-if="formGroupDirection.data.tipo_direccion === 'casa'">
                            <v-text-field 
                            label="Código Postal" 
                            type="number"
                            variant="outlined" 
                            class="w-100"
                            v-on:input="limitarCPDireccion"
                            v-model="formGroupDirection.data.cp"
                            :rules="formGroupDirection.rules.cp"
                            onkeydown="return event.key !== 'e'"
                            ></v-text-field>
                        </div>
                        <div class="col-flex-6">
                            <v-text-field 
                            label="Colonia" 
                            variant="outlined" 
                            class="w-100"
                            v-model="formGroupDirection.data.colonia"
                            :rules="formGroupDirection.rules.colonia">
                            </v-text-field>
                        </div>
                        <div class="col-flex-6">
                            <v-text-field 
                            label="Población" 
                            variant="outlined" 
                            class="w-100"
                            v-model="formGroupDirection.data.poblacion"
                            :rules="formGroupDirection.rules.poblacion">
                            </v-text-field>
                        </div>
                        <div class="col-flex-6">
                            <v-text-field 
                            label="Estado" 
                            variant="outlined" 
                            class="w-100"
                            v-model="formGroupDirection.data.estado"
                            :rules="formGroupDirection.rules.estado">
                            </v-text-field>
                        </div>
                        <div class="col-flex-12" v-if="formGroupDirection.data.tipo_direccion === 'casa'">
                            <v-textarea 
                            label="Referencia" 
                            variant="outlined" 
                            class="w-100"
                            rows="2"
                            v-model="formGroupDirection.data.referencia_domicilio"
                            :rules="formGroupDirection.rules.referencia_domicilio">
                            </v-textarea>
                        </div>
                    </form>
                </v-card-text>
                <v-card-actions class="actions_buttons">
                    <v-btn 
                        variant="flat"
                        class="text-none"
                        color="red"
                        @click="dialogDirection = false; clearFormDirection();"
                        text="Cerrar"
                    ></v-btn>
                    <v-btn 
                        variant="flat"
                        class="text-none"
                        color="indigo-darken-3"
                        :disabled="!validateFormDirection() || isLoading" 
                        @click="dialogSaveDirection = true"
                        text="Guardar"
                    ></v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </template>

    <template>
        <v-dialog v-model="dialogSaveDirection" width="500px" persistent>
            <v-card>
                <v-card-title>
                    <span class="text-h5">Confirmación</span>
                </v-card-title>
                <v-card-text>
                    <div v-if="!isLoading">
                        <div class="text-center">
                            <img src="@/assets/images/warning.png">
                        </div>
                        <div class="description-text">
                            <p v-if="typeFormDirection.type === 'R'">¿Está seguro de registrar la dirección?</p>
                            <p v-if="typeFormDirection.type === 'M'">¿Está seguro de modificar la dirección?</p>
                            <p v-if="typeFormDirection.type === 'D'">¿Está seguro de eliminar la dirección?</p>
                        </div>
                    </div>
                    <div class="content_load" v-if="isLoading">
                        <v-progress-circular
                            :size="100"
                            :width="7"
                            color="indigo-darken-3"
                            indeterminate
                        ></v-progress-circular>
                        <i>Espere un momento</i>
                        <div>Cargando la información</div>
                    </div>
                </v-card-text>
                <v-card-actions class="actions_buttons">
                    <v-btn 
                        variant="flat"
                        class="text-none"
                        color="red"
                        @click="dialogSaveDirection = false"
                        text="Cerrar"
                    ></v-btn>
                    <v-btn 
                        variant="flat"
                        class="text-none"
                        color="indigo-darken-3"
                        v-if="typeFormDirection.type === 'R'" 
                        @click="createDirectionClient()" 
                        :loading="isLoading"
                        text="Guardar"
                    ></v-btn>
                    <v-btn 
                        variant="flat"
                        class="text-none"
                        color="indigo-darken-3"
                        v-if="typeFormDirection.type === 'M'" 
                        @click="updateDirectionClient()" 
                        :loading="isLoading"
                        text="Guardar"
                    ></v-btn>
                    <v-btn 
                        variant="flat"
                        class="text-none"
                        color="indigo-darken-3"
                        v-if="typeFormDirection.type === 'D'" 
                        @click="deleteDirectionClient()" 
                        :loading="isLoading"
                        text="Guardar"
                    ></v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </template>

    <SnackbarComponent :value="snackbarData"/>
</template>
<script>
import ClientSummary from '@/components/managements/ClientSummary.vue'
import { EncryptService } from '@/services/EncryptService'
import { ManagementsService } from '@/services/ManagementsService'
import SnackbarComponent from '@/components/Snackbar'
import { ResourcesService } from '@/services/ResourcesService'
import { useUiStore } from '@/stores/ui'
export default {
    name: "AddressManagementView",
    emits: ['back'],
    props: {
        msg: String,
    },
    components: {
        ClientSummary,
        SnackbarComponent,
    },
    data() {
        return {
            searchDirecciones: '',
            isLoading: false,
            isError: {
                hasError: false,
                msg: '',
            },
            snackbarData: {
                openSnackbar: false,
                description: '',
            },
            dataSourceDirecciones: {
                data: []                
            },
            formGroupDirection: {
                data: {
                    direccion: '',
                    num_ext: '',
                    num_int: 'N/A',
                    tipo_direccion: null,
                    cp: '',
                    colonia: '',
                    poblacion: '',
                    estado: '',
                    referencia_domicilio: '',
                },
                rules: {
                    direccion: [
                        value => {
                        if (value) {
                            return true
                        }
                        return 'El campo Domicilio es obligatorio'
                        }
                    ],
                    num_ext: [
                        value => {
                        if (value) {
                            return true
                        }
                        return 'El campo Número Exterior es obligatorio'
                        }
                    ],
                    num_int: [
                        /* value => {
                        if (value) {
                            return true
                        }
                        return 'El campo Número Interior es obligatorio'
                        } */
                    ],
                    tipo_direccion: [
                        value => {
                        if (value) {
                            return true
                        }
                        return 'El campo Tipo Domicilio es obligatorio'
                        }
                    ],
                    colonia: [
                        value => {
                        if (value) {
                            return true
                        }
                        return 'El campo Colonia es obligatorio'
                        }
                    ],
                    poblacion: [
                        value => {
                        if (value) {
                            return true
                        }
                        return 'El campo Población es obligatorio'
                        }
                    ],
                    estado: [
                        value => {
                        if (value) {
                            return true
                        }
                        return 'El campo Estado es obligatorio'
                        }
                    ],
                    referencia_domicilio: [
                        value => {
                        if (value) {
                            return true
                        }
                        return 'El campo Referencia es obligatorio'
                        }
                    ],
                }
            },
            idClient: null,
            dialogDirection: false,
            dialogSaveDirection: false,
            typeFormDirection: {
                type: '',
                id: 0
            },
            infoClient: {
                id_cliente: "...",
                nombre: "...",
                saldo: "...",
                estado: "...",
            },
            typeClassConvenio: 'gray',
            permissions: true,
        }
    },
    computed:{
        ui() {
            const store = useUiStore();
            return store.ui;
        },
        headersAdress(){
            const info = this.ui?.managements;
            if (!info) return []
            return [
                {key: "direccion", title: "Domicilio" }, 
                { key: "num_ext", title: info.direccion.num_ext },  
                { key: "tipo_direccion", title: "Tipo Domicilio" },
                { key: "cp", title: info.direccion.codigoPostal },
                { key: "colonia", title: info.direccion.colonia },
                { key: "poblacion", title: info.direccion.poblacion },
                { key: "estado", title: info.direccion.estado },
                { key: "agregado_por", title: "Agregado por" },
                { key: "actions", title: "Acciones" },
            ]
        }
    },
    async mounted(){
        const store = useUiStore()
        if (Object.keys(store.ui).length === 0) {
            await store.cargarVocabulario()
        }
    },
    async created () {
        this.tipoUsuario = await EncryptService.decrypt(localStorage.getItem('TIPO'));
        const DATA_PARAMS = this.$route.params.form
        if (DATA_PARAMS === null || DATA_PARAMS === undefined || DATA_PARAMS === '') {
            this.isError.hasError = true
            this.isError.msg = `No existen datos en la URL para obtener la información del cliente. Favor de volver a ingresar al cliente`
            return;
        }
        const PARAMS = await EncryptService.decrypt(DATA_PARAMS)
        if (PARAMS === null || PARAMS === '') {
            this.isError.hasError = true
            this.isError.msg = `Los datos de la URL no fueron encriptados correctamente. Favor de volver a ingresar al cliente.`
            return;
        }
        const ARR_PARAMS = JSON.parse(PARAMS);
        this.idClient = ARR_PARAMS.id


        const ENC_TYPE = localStorage.getItem('TIPO');
        const TYPE = await EncryptService.decrypt(ENC_TYPE);
        if (TYPE === 'Gestor' || TYPE === 'Colaborador' || TYPE === 'Supervisor') {
            this.permissions = false;
            this.dataSourceDirecciones.headers.pop();
        }

        this.isLoading = true
        const store = useUiStore()
        if (Object.keys(store.ui).length === 0) {
            await store.cargarVocabulario()
        }
        await this.getClientInformation()
        await this.getDirectionsHomeAndWorkByClient()
        this.isLoading = false
    },
    methods: {
        getClientInformation: async function () {
            const ENC_CLIENT = await EncryptService.encrypt(this.idClient)
            await ManagementsService.getClientInformation(ENC_CLIENT).then(
                (responseData) => {
                    if (!responseData.error) {
                        this.infoClient = responseData.response
                        this.infoClient.total = ResourcesService.moneyFormat(this.infoClient.total)
                        switch (this.infoClient.estado) {
                            case 'Convenio Activo':
                            case 'Convenio Completado':
                            case 'Pago Intención Activo':
                            case 'Pago Intención Completado':
                                this.typeClassConvenio = 'green';
                                break;
                            case 'Sin convenio':
                                this.typeClassConvenio = 'gray';
                                break;
                            case 'Convenio Cancelado':
                            case 'Pago Intención Cancelado':
                                this.typeClassConvenio = 'red';
                                break;
                            default:
                                this.typeClassConvenio = 'gray';
                        }
                    } else {
                        this.snackbarData.description = responseData.msg
                        this.snackbarData.openSnackbar = true
                    }
                }
            )
        },
        getDirectionsHomeAndWorkByClient: async function () {
            this.isLoading = true
            const ENC_CLIENT = await EncryptService.encrypt(this.idClient)
            await ManagementsService.getDirectionsHomeAndWorkByClient(ENC_CLIENT).then(
                (responseData) => {
                    if (!responseData.error) {
                        let arrDirections = []
                        for (const element of responseData.response) {
                            arrDirections.push({
                                id_direccion: (element.id_direccion === null || element.id_direccion === '') ? 'N/A' : element.id_direccion,
                                id_cliente: (element.id_cliente === null || element.id_cliente === '') ? 'N/A' : element.id_cliente,
                                cuadrante: (element.cuadrante === null || element.cuadrante === '') ? 'N/A' : element.cuadrante,
                                zona_geo: (element.zona_geo === null || element.zona_geo === '') ? 'N/A' : element.zona_geo,
                                direccion: (element.direccion === null || element.direccion === '') ? 'N/A' : element.direccion,
                                num_ext: (element.num_ext === null || element.num_ext === '') ? 'N/A' : element.num_ext,
                                num_int: (element.num_int === null || element.num_int === '') ? 'N/A' : element.num_int,
                                tipo_direccion: (element.tipo_direccion === null || element.tipo_direccion === '') ? 'N/A' : element.tipo_direccion,
                                cp: (element.cp === null || element.cp === '') ? 'N/A' : element.cp,
                                colonia: (element.colonia === null || element.colonia === '') ? 'N/A' : element.colonia,
                                poblacion: (element.poblacion === null || element.poblacion === '') ? 'N/A' : element.poblacion,
                                estado: (element.estado === null || element.estado === '') ? 'N/A' : element.estado,
                                created_at: (element.created_at === null || element.created_at === '') ? 'N/A' : element.created_at,
                                updated_at: (element.updated_at === null || element.updated_at === '') ? 'N/A' : element.updated_at,
                                referencia_domicilio: (element.referencia_domicilio === null || element.referencia_domicilio === '') ? 'N/A' : element.referencia_domicilio,
                                agregado_por: (element.agregado_por === null || element.agregado_por === '') ? 'N/A' : element.agregado_por,
                            })
                        }
                        this.dataSourceDirecciones.data = arrDirections
                    } else {
                        this.snackbarData.description = responseData.msg
                        this.snackbarData.openSnackbar = true
                    }
                }
            )
            this.isLoading = false
        },
        editDirection: function (item) {
            this.typeFormDirection.type = 'M'
            this.typeFormDirection.id = item.id_direccion
            this.dialogDirection = true

            this.formGroupDirection.data.direccion = item.direccion
            this.formGroupDirection.data.num_ext = item.num_ext
            this.formGroupDirection.data.num_int = item.num_int
            this.formGroupDirection.data.tipo_direccion = item.tipo_direccion
            this.formGroupDirection.data.cp = item.cp
            this.formGroupDirection.data.colonia = item.colonia
            this.formGroupDirection.data.poblacion = item.poblacion
            this.formGroupDirection.data.estado = item.estado
            this.formGroupDirection.data.referencia_domicilio = item.referencia_domicilio
        },
        clearFormDirection: function () {
            this.formGroupDirection.data.direccion = ''
            this.formGroupDirection.data.num_ext = ''
            this.formGroupDirection.data.num_int = 'N/A'
            this.formGroupDirection.data.tipo_direccion = ''
            this.formGroupDirection.data.cp = ''
            this.formGroupDirection.data.colonia = ''
            this.formGroupDirection.data.poblacion = ''
            this.formGroupDirection.data.estado = ''
            this.formGroupDirection.data.referencia_domicilio = ''
        },
        validateFormDirection: function () {
            let direccion = this.formGroupDirection.data.direccion
            let num_ext = this.formGroupDirection.data.num_ext
            let tipo_direccion = this.formGroupDirection.data.tipo_direccion
            let colonia = this.formGroupDirection.data.colonia
            let poblacion = this.formGroupDirection.data.poblacion
            let estado = this.formGroupDirection.data.estado
            let referencia_domicilio = this.formGroupDirection.data.referencia_domicilio

            if (direccion === null || direccion === '' || direccion === undefined) {
                return false
            }
            if (num_ext === null || num_ext === '' || num_ext === undefined) {
                return false
            }
            if (tipo_direccion === null || tipo_direccion === '' || tipo_direccion === undefined) {
                return false
            }
            if (tipo_direccion === 'casa') {
                if (referencia_domicilio === null || referencia_domicilio === '' || referencia_domicilio === undefined) {
                return false
                }
            }
            if (colonia === null || colonia === '' || colonia === undefined) {
                return false
            }
            if (poblacion === null || poblacion === '' || poblacion === undefined) {
                return false
            }
            if (estado === null || estado === '' || estado === undefined) {
                return false
            }
            
            return true
        },
        deleteDirection: function (item) {
            this.typeFormDirection.type = 'D'
            this.typeFormDirection.id = item.id_direccion
            this.dialogSaveDirection = true
        },
        createDirectionClient: async function () {
            const REQUEST_FORM = await this.createRequestFormDirection()
            await ManagementsService.createDirectionClient(REQUEST_FORM).then(
                async (responseData) => {
                    if (!responseData.error) {
                        this.snackbarData.description = `¡Registro de Domicilio Exitosa!`
                        this.snackbarData.openSnackbar = true
                        this.dialogDirection = false
                        this.dialogSaveDirection = false
                        this.clearFormDirection()
                        await this.getDirectionsHomeAndWorkByClient()
                    } else {
                        this.snackbarData.description = responseData.msg
                        this.snackbarData.openSnackbar = true
                    }
                }
            );
        },
        updateDirectionClient: async function () {
            const REQUEST_FORM = await this.createRequestFormDirection()
            const ENC_ID = await EncryptService.encrypt(this.typeFormDirection.id.toString())
            await ManagementsService.updateDirectionClient(REQUEST_FORM, ENC_ID).then(
                async (responseData) => {
                    if (!responseData.error) {
                        this.snackbarData.description = `¡Modificación de Domicilio Exitosa!`
                        this.snackbarData.openSnackbar = true
                        this.dialogDirection = false
                        this.dialogSaveDirection = false
                        this.clearFormDirection()
                        await this.getDirectionsHomeAndWorkByClient()
                    } else {
                        this.snackbarData.description = responseData.msg
                        this.snackbarData.openSnackbar = true
                    }
                }
            );
        },
        createRequestFormDirection: async function () {
            let id_cliente = await EncryptService.encrypt(this.idClient.toString())
            
            let id_direccion = await EncryptService.encrypt(this.typeFormDirection.id.toString())

            let direccion = this.formGroupDirection.data.direccion
            direccion = direccion.toString().trim()
            direccion = await EncryptService.encrypt(direccion)

            let num_ext = this.formGroupDirection.data.num_ext
            num_ext = num_ext.toString().trim()
            num_ext = await EncryptService.encrypt(num_ext)

            let num_int = this.formGroupDirection.data.num_int
            if (num_int !== null && num_int !== '' && num_int !== undefined && num_int !== 0) {
                num_int = num_int.toString().trim()
                num_int = await EncryptService.encrypt(num_int)
            } else {
                num_int = 'N/A'
            }

            let tipo_direccion = this.formGroupDirection.data.tipo_direccion
            tipo_direccion = tipo_direccion.toString().trim()
            tipo_direccion = await EncryptService.encrypt(tipo_direccion)

            let cp = this.formGroupDirection.data.cp
            cp = cp.toString().trim()
            cp = await EncryptService.encrypt(cp)

            let colonia = this.formGroupDirection.data.colonia
            colonia = colonia.toString().trim()
            colonia = await EncryptService.encrypt(colonia)

            let poblacion = this.formGroupDirection.data.poblacion
            poblacion = poblacion.toString().trim()
            poblacion = await EncryptService.encrypt(poblacion)

            let estado = this.formGroupDirection.data.estado
            estado = estado.toString().trim()
            estado = await EncryptService.encrypt(estado)

            let referencia_domicilio = this.formGroupDirection.data.referencia_domicilio
            if (referencia_domicilio !== null && referencia_domicilio !== '' && referencia_domicilio !== undefined && referencia_domicilio !== 0) {
                referencia_domicilio = referencia_domicilio.toString().trim()
                referencia_domicilio = await EncryptService.encrypt(referencia_domicilio)
            } else {
                referencia_domicilio = null
            }

            const USERNAME = localStorage.getItem('USERNAME')

            const REQUEST_FORM = {
                id_cliente: id_cliente,
                id_direccion: id_direccion,
                direccion: direccion,
                num_ext: num_ext,
                num_int: num_int,
                tipo_direccion: tipo_direccion,
                cp: cp,
                colonia: colonia,
                poblacion: poblacion,
                estado: estado,
                referencia_domicilio: referencia_domicilio,
                agregado_por: USERNAME
            }

            return REQUEST_FORM
        },
        deleteDirectionClient: async function () {
            const ENC_ID = await EncryptService.encrypt(this.typeFormDirection.id.toString())
            await ManagementsService.deleteDirectionClient(ENC_ID).then(
                async (responseData) => {
                    if (!responseData.error) {
                        this.snackbarData.description = `¡Eliminación de Domicilio Exitosa!`
                        this.snackbarData.openSnackbar = true
                        this.dialogSaveDirection = false
                        await this.getDirectionsHomeAndWorkByClient()
                    } else {
                        this.snackbarData.description = responseData.msg
                        this.snackbarData.openSnackbar = true
                    }
                }
            );
        },
        limitarCPDireccion: function () {
            this.formGroupDirection.data.cp = this.formGroupDirection.data.cp.replace(/\D/g, '');
            if (this.formGroupDirection.data.cp.length > 5) {
                this.formGroupDirection.data.cp = this.formGroupDirection.data.cp.slice(0, 5);
            }
        },
    }
}
</script>
<style scoped>
    .title_container {
        width: 100%;
        display: flex; 
        justify-content: space-between;
        align-items: center;
        min-height: 50px;
        border-bottom: 1px solid #E3E3E3;
    }
    .title_section {
        width: 25%; 
        display: flex;  
        justify-content: center;
        font-size: 10pt;
    }
    .title_item {
        font-weight: 600;
        margin-right: 4px;
    }
    .container_submenu {
        height: calc(100% - 50px);
        overflow: auto;
        margin-bottom: 30px;
    }
</style>